const gatewaysService = {
  async getGateways() {
    try {
      const gateways = (await axios.get("/gateways")).data;

      return gateways;
    } catch (error) {
      throw error;
    }
  }
};

module.exports = gatewaysService;
